import { useRef } from 'react';
import RichText from '@/components/elements/RichText';
import Container from '@/components/global/Container';
import { IBlocksRichTextFragmentFragment } from '@/graphql/__generated__/global/types';
import { useGsapContext } from '@/hooks/useGsapContext';
import { ScrollTrigger, gsap } from '@/lib/gsap';

const BlockRichText = ({ richText }: IBlocksRichTextFragmentFragment) => {
    const ref = useRef<HTMLDivElement>(null);

    useGsapContext(() => {
        gsap.registerPlugin(ScrollTrigger);

        if (ref.current) {
            const timeline = gsap.timeline({
                scrollTrigger: {
                    id: 'block-rich-text',
                    trigger: ref.current,
                    start: 'top bottom',
                    end: 'top bottom-=30%',
                    scrub: 1,
                },
            });

            timeline.fromTo(
                ref.current,
                {
                    opacity: 0,
                    y: 100,
                },
                {
                    opacity: 1,
                    y: 0,
                }
            );

            return () => {
                timeline.kill();
            };
        }
    }, []);

    return (
        <Container>
            <div ref={ref}>
                <RichText content={richText as string} />
            </div>
        </Container>
    );
};

export default BlockRichText;
